import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Dropzone from 'react-dropzone';
import ErrorAlert from 'components/ui/ErrorAlert';
import { withTranslation } from 'react-i18next';
import { getSignedUrl } from '../../../../utils/DocumentsAPIUtils';
const maxSize = 2000000;
const acceptedFileTypes = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/pdf',
    'image/jpeg',
    'image/png',
    '.eml',
    '.msg',
    'message/rfc822',
    'application/vnd.ms-outlook',
];
class DocumentUpload extends Component {
    constructor(props) {
        super(props);
        this.getSignedUrl = async (nextProps) => {
            var _a;
            try {
                const { data, errors } = await getSignedUrl(nextProps.uploadedFileUrl);
                const signedUrl = (_a = data === null || data === void 0 ? void 0 : data.getSignedUrl) === null || _a === void 0 ? void 0 : _a.signedUrl;
                this.setState({
                    documentUrl: signedUrl,
                    uploadedFileUrl: nextProps.uploadedFileUrl,
                });
            }
            catch (e) {
                console.error('DocumentUpload, failed to get signed URL: ', e);
            }
        };
        this.handleAcceptDrop = (files) => this.props.onDrop(files);
        this.handleRejectDrop = (files) => {
            this.setState({
                rejectedFiles: files.map((f) => f.name),
            }, () => {
                setTimeout(() => {
                    this.setState({ rejectedFiles: [] });
                }, 4000);
            });
        };
        this.state = {
            rejectedFiles: [],
            uploadedFileUrl: '',
            documentUrl: '',
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.uploadedFileUrl &&
            this.state.uploadedFileUrl !== nextProps.uploadedFileUrl) {
            this.getSignedUrl(nextProps);
        }
    }
    renderErrors() {
        if (!this.state.rejectedFiles || this.state.rejectedFiles.length === 0) {
            return null;
        }
        const { t } = this.props;
        return (React.createElement(ErrorAlert, { title: t('MAX_FILE_SIZE_EXCEED') },
            React.createElement("ul", null, this.state.rejectedFiles.map((name) => (React.createElement("li", null, name))))));
    }
    renderDropzone() {
        const { uploadedFileUrl } = this.props;
        if (uploadedFileUrl) {
            return null;
        }
        const className = classnames('flex', 'justify-center', 'items-center', 'w-full', 'h-full', 'border', 'block', 'border-dashed', 'p-4', 'dropzone-wrapper');
        const { t, dropZoneClassNames } = this.props;
        return (React.createElement(Dropzone, { accept: acceptedFileTypes.join(','), className: `${className} ${dropZoneClassNames}`, onDropAccepted: this.handleAcceptDrop, onDropRejected: this.handleRejectDrop, maxSize: maxSize },
            this.props.uploadPending && (React.createElement("div", { className: "flex items-center" },
                React.createElement("i", { className: "fa fa-spinner fa-spin" }),
                React.createElement("span", null, t('UPLOADING')))),
            !this.props.uploadPending && (React.createElement("p", { className: "block" }, t('DROP_DOCUMENT_TO_ADD')))));
    }
    renderUploadedFile() {
        const { uploadedFileUrl } = this.props;
        if (!uploadedFileUrl) {
            return null;
        }
        const documentUrl = this.state.documentUrl;
        return (React.createElement("a", { className: "flex items-center", href: documentUrl, target: "_blank", rel: "noreferrer" },
            React.createElement("i", { className: "fa fa-file-image-o fa-3x" })));
    }
    render() {
        return (React.createElement("fieldset", { className: "" },
            React.createElement("div", { className: "block mb-4" },
                this.renderDropzone(),
                this.renderUploadedFile()),
            this.renderErrors()));
    }
}
DocumentUpload.propTypes = {
    onDrop: PropTypes.func.isRequired,
    uploadPending: PropTypes.bool.isRequired,
    uploadedFileUrl: PropTypes.string,
};
export default withTranslation()(DocumentUpload);
